import React, { FC } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
// Components
import {
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
  Theme
} from '@mui/material';
import { ExpandMore, Edit } from '@mui/icons-material';
import { formatInputPhoneNumber } from '../../../../helpers';
import { IVendor } from '../../../../models';

interface IMobileVendor {
  original: IVendor;
  handleEdit?: (val: IVendor) => void;
}

export const MobileVendor: FC<IMobileVendor> = ({ original, handleEdit }) => {
  const classes = useStyles();
  const { name, type, sageId, phoneNumber, faxNumber, vendorType } = original;

  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">{name}</Typography>
          <div className={classes.buttonsWrapper}>
            {handleEdit && (
              <IconButton
                className={classes.editButton}
                color="primary"
                onClick={e => {
                  e.stopPropagation();
                  handleEdit(original);
                }}
              >
                <Edit />
              </IconButton>
            )}
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Name:
          </FormLabel>
          <Typography component="span" variant="body2">
            {name || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Subcontractor Type:
          </FormLabel>
          <Typography component="span" variant="body2">
            {type || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Vendor Type:
          </FormLabel>
          <Typography component="span" variant="body2">
            {vendorType || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Sage ID:
          </FormLabel>
          <Typography component="span" variant="body2">
            {sageId || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Phone Number:
          </FormLabel>
          <Typography component="span" variant="body2">
            {phoneNumber ? formatInputPhoneNumber(phoneNumber) : '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Fax Number:
          </FormLabel>
          <Typography component="span" variant="body2">
            {faxNumber ? formatInputPhoneNumber(faxNumber) : '--'}
          </Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  editButton: {
    padding: `2px 5px`
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  buttonsWrapper: {
    display: 'flex'
  }
}));
